import * as Yup from 'yup'

export const ValidationSchema = (action) => {
	return Yup.object().shape({
		grossSalary: Yup.string().required({ key: 'required' }).nullable(),
		staffUnitsCount: action.add_workplace ? Yup.number().required({ key: 'required' })
			.positive()
			.integer({ key: 'staff.enter_integer' })
			.max(1000, { key: 'staff.max_value' }) // Задаем ограничение на максимум
			.nullable() : Yup.number().required({ key: 'required' }).nullable(),
	})
}
